import React from 'react'
import BGBlock from './BGBlock'
import { AiOutlineCompass } from "@react-icons/all-files/ai/AiOutlineCompass";

import PicCont from './PicCont';
import trust from '../public/Pictures/trust.png'
import percentage from '../public/Pictures/percentage.png'
import bill from '../public/Pictures/bill.png'
import analytics from '../public/Pictures/analytics.png'
import white from '../public/Pictures/model3_header.jpg'
import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";

const B2BModelThree = ({summary}) => {

  return <section className='b2bModel' id='model3' >
        {!summary &&  <BGBlock src={white} >
        <div className="row">
            <AiOutlineCompass /> <h2>AV Compass</h2>
        </div>
    </BGBlock>}
    <div className="partOne">
    <strong className="bTitle">{summary ? 'AV Compass' :'What is it?'}</strong>
     
        <p>
        Quotes and service provided by sister company <strong>AV Compass</strong>. Prices are not publicly available in this platform and our partners have the oportunity to modify them before sending the quote to the final client.<br/><br/>
Within the private Partners Portal at Miami Sound Rental, partners have access to all the estimates and quoting information generated by AV Compass to <strong>manage the pricing for each one of the orders</strong>.   
        </p>
    </div>
    <div className="partTwo">
        <strong className="bTitle">How does it work?</strong>
        <div className="row">
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={trust}  />
                <strong className="cTitle bold">Outsource AV Productions</strong>
                </div>
            <div className="divP">
                <p>
                <strong>In-house AV solutions</strong> that provide the <strong>best service</strong>; by leveraging on our technology and data driven operations for delivering the best event experience and real time & agile communication with our partners in each step.<br/><br/>
                <strong>We backup our partner in all the event phases</strong>: from AV design, quoting, planning, executing and managing all financial aspects. We ensure <strong>flawless execution</strong>, maximum <strong>time and cost efficiency</strong> and the best attendee experience. <br/><br/>
                All with the guarantee of the best AV service in Miami. That allows our partner to rely in our quality standards so they can stay focused on their own business.
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={bill}  />
                <strong className="cTitle bold">Full Control of your prices</strong>
                </div>
            <div className="divP second">
                <p>
                Partners have access to our online equipment catalog and to the <strong>AV packages specifically designed for their venue</strong>. From our platform, they can make in minutes estimates and quotations with the prices settled in our partnership and <strong>add the markup</strong> they consider. If they prefer, these can be assisted by their account manager.<br/><br/>
                Once the order is created and the desired markup is added; the breakdown, order review and invoice are generated with the final pricing, the one  the customer will receive.
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={analytics}  />
                <strong className="cTitle bold">Reliability through technology </strong>
                </div>
            <div className="divP">
                <p>
                Our unique <strong>AV proprietary technology</strong> makes our service quality and efficiency <strong>standards well above average</strong>.<br/><br/>
                Our data model for managing operations, makes them 99% foolproof.  All components are <strong>connected and synchronized in real time</strong>: inventory, taskforce, execution times, etc. This operating model makes our response and execution times above average. Our margin of error tends to be zero. We are flexible and agile facing changes and contingencies <br/><br/>
                Our experts craft customized AV packages for each room.  We put our <strong>technology and digital tools</strong> at partner&apos;s service which radically improves RFP response time.<br/><br/>

                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={percentage}  />
                <strong className="cTitle bold">Tiered Discount Schedule</strong>
                </div>
            <div className="divP last">
                <p>
                Progressive discount schedule based on volume of sales for the previous month:<br/><br/>
                <div className='discountRow'><strong>First Month:</strong><span className='discount'>20% Discount</span> </div><br/>
                 
                <div className='discountRow headRow'><strong>After fist month:</strong><span className='discount'>Discount</span> </div><br/>
                <div className='discountRow'><span>Less than <strong>$10,000</strong> in sales:</span><span className='discount'>10%</span> </div>
                <div className='discountRow'><span>Between <strong>$10,000</strong> and <strong>$30,000</strong> in sales:</span><span className='discount'>20%</span> </div>
                <div className='discountRow'><span>More than <strong>$30,000</strong> in sales:</span><span className='discount'>30%</span> </div><br/>
                <strong>Discounts are directly applied to the venue</strong> in each service.
                </p>
                </div>
            </div>
        </div>
    </div>
    <div className="partThree">
        <strong className="bTitle">How does it benefit your business?</strong>
        <div className='row'>
            <div className="point">
                <strong className='pointTitle'><IoIosArrowForward />Substantial profitability  increase thanks to the option to personalize markups depending on the type of event and client.  </strong>
                <p>
                This model is especially advantageous for upscale venues looking to incorporate additional charges, offering partners the opportunity to increase their commissions with ease.
                </p>
            </div>
            <div className="point ">
                <strong className='pointTitle'><IoIosArrowForward /> We ensure reliable service through dedicated team</strong>
                <p>
                Thanks to our data-driven service planning and delivery, we ensure flawless execution. We are the top-rated AV provider in South Florida. We guarantee the same quality of service.
                </p>
            </div>
            <div className="point">
                <strong className='pointTitle'><IoIosArrowForward /> Partner portal: one stop shop to manage everything related to the partnership and dedicated account manager </strong>
                <p>
                Through the Partner Portal, the venue will have easy access to all relevant information to manage everything related to the partnership. He will have access to tools to maximize results and monetize the relationship on your own or with the assistance of your dedicated account manager when required.
                </p>
            </div>
            <div className="point last">
                <strong className='pointTitle'><IoIosArrowForward />  Seamless integrated partnership operations </strong>
                <p>
                Our integrated system simplifies operations, from communication between team members to manage markups and accounting processes, making it effortless for our partners to maximize impact in their business and profitability.  </p>
            </div>
        </div>
    </div>

  </section>
}

export default B2BModelThree